import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@mui/material";
import React from "react";
import PropTypes from "prop-types";
import { AppColors } from "../resources/AppColors";

// ! GET RID OF THIS COMPONENT, USE BootstrapDialog instead
const DialogMonitoring = (props) => {
  const {
    handleShow,
    handleConfirm,
  } = props;

  const handleOnClose = (event, reason) => {
    if (reason === "backdropClick") {
      return false;
    } else {
      handleShow();
    }
  };

  return (
    <Dialog
      style={{ borderRadius: 10, boxShadow: "3px 3px 3px 1px rgba(0,0,0,.16)" }}
      maxWidth={props.size === true ? "md" : "sm"}
      fullWidth={true}
      open={props.show}
      onClose={handleOnClose}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
    >
      <DialogTitle
        style={{ color: AppColors.PRIMARY }}
        id="scroll-dialog-title"
      >
        <Typography variant='subtitle'>
          {props.title}
        </Typography>
      </DialogTitle>
      <DialogContent dividers={true}>{props.children}</DialogContent>
      <DialogActions>
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="flex-end"
        >
          <Grid
            container
            direction="row"
            justifyContent="flex-end"
            alignItems="center"
          >
            <Button
              onClick={handleOnClose}
              style={{ backgroundColor: AppColors.PRIMARY, minWidth: "8em", marginRight: "1em" }}
              variant="contained"
            >
              <Typography variant='button_text'>
                {props.textCancelButton}
              </Typography>
            </Button>
            <Button
              onClick={handleConfirm}
              style={{ backgroundColor: props.buttonColor, minWidth: "8em" }}
              color="primary"
              variant="contained"
              data-cy="dialog-confirm-button"
            >
              <Typography variant='button_text'>
                {props.textConfirmButton}
              </Typography>
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};
DialogMonitoring.defaultProps = {
  show: false,
  size: false,
  backdrop: "static",
};
DialogMonitoring.propTypes = {
  handleShow: PropTypes.func.isRequired,
  handleConfirm: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.object.isRequired,
  buttonColor: PropTypes.string,
  textCancelButton: PropTypes.string.isRequired,
  textConfirmButton: PropTypes.string.isRequired,
  show: PropTypes.bool,
  size: PropTypes.bool,
  backdrop: PropTypes.string,
};

export default DialogMonitoring;
